import { Toast } from '@stores/toaster';

import { contactAccessOrAffiliation } from '../CandidatesShow/components/ContactAccess';

export const FAILED_SUBSET: Toast = {
  heading: 'Failed to select a subset',
  text: 'Something went wrong. Please try again later.',
  icon: 'error'
};
export const SUCCESS_UPDATE_CONTACT_ACCESS = (hasTeamAccessControl: boolean): Toast => {
  return {
    heading: `${contactAccessOrAffiliation(hasTeamAccessControl)} updated`,
    text: `Candidate ${contactAccessOrAffiliation(hasTeamAccessControl).toLowerCase()} have been updated.`,
    icon: 'success'
  };
};
export const FAILED_UPDATE_CONTACT_ACCESS = (hasTeamAccessControl: boolean): Toast => {
  return {
    heading: `Failed to update ${contactAccessOrAffiliation(hasTeamAccessControl).toLowerCase()}`,
    text: `${contactAccessOrAffiliation(hasTeamAccessControl)} could not be changed. Please try again later, or contact support.`,
    icon: 'error'
  };
};
